import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router/dom';

import { router } from './app/router';
import { AppErrorBoundary } from './app/AppErrorBoundary';
import { ReleaseStatus } from './app/ReleaseStatus';
import { SaveBootstrap } from './features/save/SaveBootstrap';
import { GAME_PLATFORM, initializeGamePlatform } from './platform/gamePlatform';
import { registerGameServiceWorker } from './pwa';
import { initializeMonitoring } from './monitoring';
import './styles/global.css';

document.documentElement.dataset.gamePlatform = GAME_PLATFORM;
document.documentElement.dataset.buildId = __APP_BUILD_ID__;
void initializeGamePlatform().catch(() => undefined);
registerGameServiceWorker();
initializeMonitoring();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
    },
  },
});

const rootElement = document.querySelector('#root');

if (!(rootElement instanceof HTMLElement)) {
  throw new Error('Missing #root element');
}

createRoot(rootElement).render(
  <StrictMode>
    <AppErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <SaveBootstrap>
          <RouterProvider router={router} />
          <ReleaseStatus />
        </SaveBootstrap>
      </QueryClientProvider>
    </AppErrorBoundary>
  </StrictMode>,
);
